/* hoevi.js - Verhalten der Creator-Kollektionsseite.
   Vanilla, kein Build, kein Framework. Alles haengt an data-Attributen,
   damit die Sections im Theme-Editor frei sortierbar bleiben.
   Warenkorb laeuft ueber /cart/add.js und den bestehenden Cart-Drawer. */
(function () {
  'use strict';

  var FREE_SHIPPING_FALLBACK = 6900; // Cent, greift nur ohne Section-Einstellung

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    // Der Rabatt wird erst sichtbar, wenn etwas im Warenkorb liegt.
    setTimeout(rabattStatus, 600);
  }

  /* ---- Rabattcode kopieren ---------------------------------------- */
  function initCodeChips(root) {
    root.querySelectorAll('[data-hoevi-copy]').forEach(function (btn) {
      if (btn.dataset.hoeviBound) return;
      btn.dataset.hoeviBound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-hoevi-code]');
        var code = wrap ? wrap.dataset.hoeviCode : '';
        // Ein fehlgeschlagener Kopiervorgang darf nicht als Erfolg gemeldet werden,
        // sonst sucht der Besucher im Checkout einen Code, den er nie hat.
        var done = function (ok) {
          if (!wrap) return;
          wrap.classList.add(ok === false ? 'is-copyfail' : 'is-copied');
          setTimeout(function () {
            wrap.classList.remove('is-copied');
            wrap.classList.remove('is-copyfail');
          }, 5000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code)
            .then(function () { done(true); })
            .catch(function () { done(false); });
        } else {
          var f = document.createElement('textarea');
          f.value = code;
          f.setAttribute('readonly', '');
          f.style.position = 'absolute';
          f.style.left = '-9999px';
          document.body.appendChild(f);
          f.select();
          var ok = false;
          try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
          document.body.removeChild(f);
          done(ok);
        }
      });
    });
  }

  /* ---- Rabattstatus ------------------------------------------------ */
  function meldung(text, art) {
    var alt = document.querySelector('[data-hoevi-toast]');
    if (alt) alt.remove();
    var box = document.createElement('div');
    box.className = 'hoevi hv-toast' + (art === 'fehler' ? ' hv-toast--fehler' : '');
    box.setAttribute('role', 'status');
    box.setAttribute('data-hoevi-toast', '');
    box.textContent = text;
    document.body.appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-visible'); });
    setTimeout(function () {
      box.classList.remove('is-visible');
      setTimeout(function () { box.remove(); }, 400);
    }, 9000);
  }

  function markiereAktiv(code, hervorheben) {
    document.querySelectorAll('[data-hoevi-code]').forEach(function (wrap) {
      if (wrap.dataset.hoeviCode.toUpperCase() !== code.toUpperCase()) return;
      wrap.classList.add('is-active');
      if (!hervorheben) return;
      // Frueher sprang die Seite hier zum Rabattfeld. Weil es mehrere davon
      // gibt, gewann das letzte in der Seite und der Besucher landete ganz
      // unten. Die Bestaetigung uebernimmt jetzt allein der Hinweis oben,
      // dazu faerbt sich jedes Feld kurz ein.
      wrap.classList.add('is-frisch');
      setTimeout(function () { wrap.classList.remove('is-frisch'); }, 2600);
    });
  }

  function rabattStatus() {
    var chips = document.querySelectorAll('[data-hoevi-code]');
    if (!chips.length) return;

    // Kommt der Besucher gerade vom Aktivieren zurueck, bestaetigen wir das
    // sofort und raeumen die Markierung wieder aus der Adresszeile.
    var params = new URLSearchParams(window.location.search);
    var frisch = params.get('hoevi_code');
    if (frisch) {
      params.delete('hoevi_code');
      var rest = params.toString();
      history.replaceState({}, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    }

    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var aktiv = (cart.cart_level_discount_applications || []).map(function (d) {
          return (d.title || '').toUpperCase();
        });
        var codes = [];
        chips.forEach(function (w) { codes.push(w.dataset.hoeviCode); });
        codes.forEach(function (code) {
          if (aktiv.indexOf(code.toUpperCase()) > -1) markiereAktiv(code);
        });

        if (!frisch) return;
        if (aktiv.indexOf(frisch.toUpperCase()) > -1) {
          markiereAktiv(frisch, true);
          meldung('Rabatt ' + frisch + ' ist aktiv. Der Abzug erscheint im Checkout.');
        } else if (cart.item_count === 0) {
          // Bei leerem Warenkorb kann Shopify den Rabatt noch nicht ausweisen.
          markiereAktiv(frisch, true);
          meldung('Rabatt ' + frisch + ' ist gespeichert. Sobald etwas im Warenkorb liegt, wird er abgezogen.');
        } else {
          meldung('Der Rabatt konnte nicht aktiviert werden. Trag ' + frisch + ' im Checkout ein.', 'fehler');
        }
      })
      .catch(function () {
        if (frisch) meldung('Rabatt ' + frisch + ' wurde aktiviert.');
      });
  }

  /* ---- Einzelne Variante in den Warenkorb -------------------------- */
  function addToCart(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add fehlgeschlagen: ' + r.status);
      return r.json();
    });
  }

  function flashButton(btn, text) {
    // Knoepfe ohne sichtbare Beschriftung bekommen die Rueckmeldung ueber eine
    // Klasse, sonst aendert sich nur Text, den niemand sieht.
    btn.classList.add('is-done');
    var label = btn.querySelector('span:not(.visually-hidden)');
    var vorher = null;
    if (label && label.textContent.trim()) {
      vorher = label.textContent;
      label.textContent = text;
    }
    btn.setAttribute('disabled', 'disabled');
    setTimeout(function () {
      btn.classList.remove('is-done');
      if (label && vorher !== null) label.textContent = vorher;
      btn.removeAttribute('disabled');
    }, 1600);
  }

  function initAddButtons(root) {
    root.querySelectorAll('[data-hoevi-add]').forEach(function (btn) {
      if (btn.dataset.hoeviBound) return;
      btn.dataset.hoeviBound = '1';
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('aria-busy')) return;
        var ids = btn.dataset.hoeviAdd.split(',').filter(Boolean);
        if (!ids.length) return;
        var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
        btn.setAttribute('aria-busy', 'true');
        addToCart(items)
          .then(function () {
            flashButton(btn, 'Im Warenkorb');
            openCartDrawer();
          })
          .catch(function (err) {
            console.warn('[hoevi]', err);
            flashButton(btn, 'Nicht verfügbar');
          })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* ---- Hövi-Kiste -------------------------------------------------- */
  function initCrate(section) {
    var minItems = Number(section.dataset.min || 3);
    var maxItems = Number(section.dataset.max || 5);
    var shipBoxEl = section.querySelector('[data-hoevi-ship]');
    var freeFrom = Number((shipBoxEl && shipBoxEl.dataset.threshold) || FREE_SHIPPING_FALLBACK);
    var cells = section.querySelectorAll('[data-hoevi-cell]');
    var tiles = section.querySelectorAll('[data-hoevi-pick]');
    var sumEl = section.querySelector('[data-hoevi-sum]');
    var countEl = section.querySelector('[data-hoevi-count]');
    var hintEl = section.querySelector('[data-hoevi-hint]');
    var addBtn = section.querySelector('[data-hoevi-crate-add]');
    var fill = section.querySelector('[data-hoevi-ship-fill]');
    var left = section.querySelector('[data-hoevi-ship-left]');
    var shipBox = section.querySelector('[data-hoevi-ship]');
    var chosen = [];

    function render() {
      var total = chosen.reduce(function (s, p) { return s + p.price; }, 0);

      cells.forEach(function (cell, i) {
        var p = chosen[i];
        cell.innerHTML = '';
        if (p) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = '';
          cell.appendChild(img);
          var name = document.createElement('span');
          name.className = 'hv-crate__name';
          name.textContent = p.title;
          cell.appendChild(name);
        } else {
          var empty = document.createElement('span');
          empty.className = 'hv-crate__empty';
          empty.textContent = i < minItems ? 'PFLICHT' : 'OPTIONAL';
          cell.appendChild(empty);
        }
      });

      tiles.forEach(function (t) {
        var on = chosen.some(function (p) { return p.variant === t.dataset.variant; });
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!on && chosen.length >= maxItems) {
          t.setAttribute('disabled', 'disabled');
        } else {
          t.removeAttribute('disabled');
        }
      });

      if (sumEl) sumEl.textContent = euro(total);
      if (countEl) countEl.textContent = chosen.length + '/' + maxItems;
      if (addBtn) {
        if (chosen.length < minItems) {
          addBtn.setAttribute('disabled', 'disabled');
        } else {
          addBtn.removeAttribute('disabled');
        }
      }
      if (hintEl) {
        if (chosen.length === 0) {
          // Vor der ersten Auswahl waere "noch 3 Stuecke" irrefuehrend, weil
          // noch gar nichts gepackt wurde.
          hintEl.textContent = hintEl.dataset.hoeviHintEmpty || 'Such dir unten drei bis fünf Stücke aus.';
        } else if (chosen.length < minItems) {
          var fehlt = minItems - chosen.length;
          hintEl.textContent = 'Noch ' + fehlt + (fehlt === 1 ? ' Stück' : ' Stücke') + ' bis zur Kiste';
        } else if (chosen.length < maxItems) {
          hintEl.textContent = 'Platz für ' + (maxItems - chosen.length) + ' weitere';
        } else {
          hintEl.textContent = 'Kiste ist voll';
        }
      }

      var rest = Math.max(0, freeFrom - total);
      if (fill) fill.style.width = Math.min(100, (total / freeFrom) * 100) + '%';
      if (left) left.textContent = euro(rest);
      if (shipBox) {
        shipBox.classList.toggle('is-free', rest === 0);
        var offen = shipBox.querySelector('[data-hoevi-ship-todo]');
        var frei = shipBox.querySelector('[data-hoevi-ship-done]');
        if (offen) offen.hidden = rest === 0;
        if (frei) frei.hidden = rest > 0;
      }
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        var v = t.dataset.variant;
        var i = chosen.findIndex(function (p) { return p.variant === v; });
        if (i > -1) {
          chosen.splice(i, 1);
        } else if (chosen.length < maxItems) {
          chosen.push({
            variant: v,
            price: Number(t.dataset.price),
            title: t.dataset.title,
            image: t.dataset.image
          });
        }
        render();
      });
    });

    if (addBtn) {
      var laeuft = false;
      addBtn.addEventListener('click', function () {
        if (laeuft || chosen.length < minItems) return;
        laeuft = true;
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('aria-busy', 'true');
        var items = chosen.map(function (p) { return { id: Number(p.variant), quantity: 1 }; });
        addToCart(items).then(function () {
          chosen = [];
          render();
          openCartDrawer();
        }).catch(function (err) {
          console.warn('[hoevi]', err);
          if (hintEl) hintEl.textContent = 'Das hat nicht geklappt. Versuch es bitte noch einmal.';
        }).finally(function () {
          laeuft = false;
          addBtn.removeAttribute('aria-busy');
          render();
        });
      });
    }

    render();
  }

  /* ---- Rails ------------------------------------------------------- */
  function initRails(root) {
    root.querySelectorAll('[data-hoevi-rail-nav]').forEach(function (nav) {
      if (nav.dataset.hoeviBound) return;
      nav.dataset.hoeviBound = '1';
      var rail = document.getElementById(nav.dataset.hoeviRailNav);
      if (!rail) return;
      nav.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.dataset.dir === 'prev' ? -1 : 1;
          rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---- Mobile Sticky Bar ------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-hoevi-sticky]');
    if (!bar) return;
    document.body.classList.add('hoevi-has-sticky');
    var anchor = document.getElementById('hoevi-hero');
    var hidden = document.getElementById('hoevi-bundle');

    function update() {
      var pastHero = anchor ? anchor.getBoundingClientRect().bottom < 40 : window.scrollY > 400;
      var inBundle = false;
      if (hidden) {
        var b = hidden.getBoundingClientRect();
        inBundle = b.top < window.innerHeight * 0.75 && b.bottom > window.innerHeight * 0.25;
      }
      bar.classList.toggle('is-visible', pastHero && !inBundle);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- Sprungleiste ------------------------------------------------ */
  function initToc() {
    var nav = document.querySelector('[data-hoevi-toc]');
    if (!nav) return;
    if (nav.dataset.hoeviTocBound) return;
    nav.dataset.hoeviTocBound = '1';
    // Laedt der Theme-Editor die Section neu, haengt der vorherige Lauf an einem
    // Knoten, den es nicht mehr gibt. Deshalb vorher abraeumen.
    if (window.__hoeviTocAbbau) window.__hoeviTocAbbau();
    var links = [].slice.call(nav.querySelectorAll('[data-hoevi-toc-link]'));
    var ziele = [];

    links.forEach(function (a) {
      var el = document.getElementById(a.dataset.hoeviTocLink);
      if (!el) {
        // Ohne passenden Abschnitt waere es eine tote Sprungmarke.
        var li = a.closest('li');
        if (li) li.remove();
        return;
      }
      ziele.push({ link: a, el: el });
    });

    if (!ziele.length) {
      nav.hidden = true;
      return;
    }

    function markiere(aktiv) {
      ziele.forEach(function (z) {
        if (z.link === aktiv) {
          z.link.setAttribute('aria-current', 'true');
        } else {
          z.link.removeAttribute('aria-current');
        }
      });
    }

    // Die Leiste klebt per fixed, weil sticky am body-Overflow scheitert.
    var sektion = nav.closest('.shopify-section') || nav.parentElement;
    var platzhalter = document.createElement('div');
    platzhalter.setAttribute('aria-hidden', 'true');
    sektion.parentNode.insertBefore(platzhalter, sektion);

    // Der Theme-Header klappt beim Scrollen ein und scrollt mobil ganz weg.
    // --header-height wird dabei nicht neu gesetzt. Deshalb die echte Unterkante
    // messen, sonst bleibt ueber der Leiste ein offenes Band stehen.
    var kopf = document.querySelector('.cc-header--sticky') || document.querySelector('.cc-header');
    function kopfhoehe() {
      if (!kopf) return 0;
      return Math.max(0, kopf.getBoundingClientRect().bottom);
    }

    var ruhepunkt = 0;
    function messen() {
      var fest = sektion.classList.contains('hoevi-toc--fixed');
      if (fest) return;
      platzhalter.style.height = '0px';
      ruhepunkt = sektion.getBoundingClientRect().top + window.scrollY;
    }

    function pruefen() {
      var fest = sektion.classList.contains('hoevi-toc--fixed');
      var oben = kopfhoehe();
      if (!fest) {
        // Im geloesten Zustand steht die echte Position jederzeit fest. Einmal
        // gespeichert waere sie veraltet, sobald sich das Layout darueber aendert.
        ruhepunkt = sektion.getBoundingClientRect().top + window.scrollY;
      }
      if (!fest && window.scrollY + oben >= ruhepunkt) {
        sektion.classList.add('hoevi-toc--fixed');
        platzhalter.style.height = nav.offsetHeight + 'px';
      } else if (fest && window.scrollY + oben < ruhepunkt) {
        sektion.classList.remove('hoevi-toc--fixed');
        platzhalter.style.height = '0px';
      }
      sektion.style.setProperty('--hv-toc-top', oben + 'px');
    }

    messen();
    pruefen();
    window.addEventListener('scroll', pruefen, { passive: true });
    // Der Header animiert sein Ein- und Ausklappen weiter, nachdem das Scrollen
    // schon aufgehoert hat.
    if (kopf) kopf.addEventListener('transitionend', pruefen);
    function beiResize() {
      sektion.classList.remove('hoevi-toc--fixed');
      platzhalter.style.height = '0px';
      messen();
      pruefen();
    }
    window.addEventListener('resize', beiResize);

    // Nach dem Filtern scrollt das Theme nur um den Header herum. Steht die
    // Leiste fest, landet der Kopf der Ergebnisse dahinter.
    function nachFilter() {
      var ergebnis = document.getElementById('filter-results');
      if (!ergebnis || !sektion.classList.contains('hoevi-toc--fixed')) return;
      var oben = ergebnis.getBoundingClientRect().top;
      var unterkante = kopfhoehe() + nav.offsetHeight;
      if (oben < unterkante) {
        window.scrollTo({ top: window.scrollY + oben - unterkante - 12, behavior: 'auto' });
      }
    }
    document.addEventListener('on:facet-filters:updated', nachFilter);

    var obs = null;
    if ('IntersectionObserver' in window) {
      var sichtbar = {};
      obs = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { sichtbar[e.target.id] = e.isIntersecting; });
        var treffer = null;
        ziele.forEach(function (z) { if (!treffer && sichtbar[z.el.id]) treffer = z.link; });
        markiere(treffer);
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      ziele.forEach(function (z) { obs.observe(z.el); });
    }

    window.__hoeviTocAbbau = function () {
      if (obs) obs.disconnect();
      window.removeEventListener('scroll', pruefen);
      window.removeEventListener('resize', beiResize);
      document.removeEventListener('on:facet-filters:updated', nachFilter);
      if (kopf) kopf.removeEventListener('transitionend', pruefen);
      if (platzhalter.parentNode) platzhalter.parentNode.removeChild(platzhalter);
      window.__hoeviTocAbbau = null;
    };
  }

  /* ---- Start ------------------------------------------------------- */
  function boot(root) {
    initCodeChips(root);
    initAddButtons(root);
    initRails(root);
    root.querySelectorAll('[data-hoevi-crate-section]').forEach(function (s) {
      if (s.dataset.hoeviBound) return;
      s.dataset.hoeviBound = '1';
      initCrate(s);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
    initSticky();
    initToc();
    rabattStatus();
  });

  // Nach dem Filtern tauscht das Theme das Grid aus. Danach erneut binden.
  document.addEventListener('on:facet-filters:updated', function () { boot(document); });
  // Im Theme-Editor werden Sections einzeln neu geladen.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    initToc();
  });
})();
